import React, { useState, useCallback } from 'react';
import DsaNav from './DsaNav';
import DsaWorkspace from './DsaWorkspace';
import '../../styles/dsa-workspace.css';
import '../../styles/dsa-nav.css';

/*
 * NavigationPage — free browsing of the problem bank (separate from the session
 * modes, which are driven by Session Settings). Browse all DSA problems and open
 * any one in the full workspace.
 */
const NavigationPage = ({ config, registerSend }) => {
  const [qid, setQid] = useState(null);
  const open = useCallback((id) => setQid(Number(id)), []);
  if (qid == null) return <DsaNav onOpen={open} />;
  return (
    <DsaWorkspace
      key={qid}
      questionId={qid}
      config={config}
      registerSend={registerSend}
      onBack={() => setQid(null)}
      onOpenQuestion={open}
    />
  );
};

export default NavigationPage;
